import { useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { uploadFile } from "../FileField";
import { fileTrack } from "./trackBits";

const MAX = 200 * 1024 * 1024;

export const AudioUploader = ({ onAdd }) => {
  const [status, setStatus] = useState(null);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    const ok = files.filter((f) => f.size <= MAX);
    if (ok.length < files.length) toast.error("Some files are over 200MB and were skipped.");
    let done = 0;
    for (const f of ok) {
      setStatus(`${done + 1}/${ok.length} · 0%`);
      try {
        const data = await uploadFile(f, (p) => setStatus(`${done + 1}/${ok.length} · ${p}%`));
        onAdd([fileTrack(data.url, f.name)]);
      } catch (err) {
        toast.error(`${f.name}: ${formatApiError(err)}`);
      }
      done += 1;
    }
    setStatus(null);
    if (ok.length) toast.success(`${ok.length} TRACK${ok.length > 1 ? "S" : ""} UPLOADED — SAVE TO PUBLISH`);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <label data-testid="music-upload-btn" className={`cursor-pointer flex items-center gap-2 px-4 py-2.5 border border-dashed border-[#00F0FF]/50 text-[#00F0FF] font-mono text-[11px] tracking-[0.2em] hover:bg-[#00F0FF]/10 ${status ? "pointer-events-none opacity-70" : ""}`}>
        <Upload size={14} /> {status ? `UPLOADING ${status}` : "UPLOAD MY OWN AUDIO"}
        <input data-testid="music-upload-input" type="file" multiple accept=".mp3,.wav,.m4a,.aac,.ogg,.flac,audio/*" className="hidden" onChange={onFiles} disabled={!!status} />
      </label>
      <span className="text-xs text-zinc-400">MP3, WAV, M4A, AAC, OGG or FLAC · up to 200MB each · plays in full</span>
    </div>
  );
};
